import { makeStyles } from '@material-ui/styles';
import theme from '../../../theme';
import useSessionStore from '@services/stores/SessionStore';

const useStyles = makeStyles({
    promotionPriceWrapper: {
        display: 'flex',
        alignItems: 'center',
        margin: '16px auto 0',
        padding: '8px 16px',
        gap: 8,
        color: 'white',
        background: '#111',
        width: 'fit-content',
        justifyContent: 'center',
        fontFamily: 'Chronicle, "Open Sans", sans-serif',
        '.blackfriday &': {
            color: 'white',
            background: 'transparent',
            border: '1px solid #fff',
        },
        [theme.breakpoints.up('md')]: {
            justifyContent: 'flex-start',
            margin: '16px 0 0',
        },
    },
    promotionPrice: {
        fontSize: 18,
    },
});

export default function PromotionPrice(
    {
        available,
        streamIds = [],
        prices,
    }
) {
    const formatPrice = useSessionStore((state) => state.methods.formatPrice);
    const sessionActions = useSessionStore((state) => state.methods)
    const isSaleOngoing = useSessionStore((state) => state.isSaleOngoing)
    const classes = useStyles();

    if (!isSaleOngoing) {
        return null;
    }

    function calculate(discount, prices) {
        if (prices?.listPrice > prices?.price) {
            return '';
        }

        const originalPrice = prices?.price;
        return formatPrice((originalPrice - (originalPrice * (discount / 100))));
    }

    function renderLabel(label) {
        return <>
            <span className>{label.label}</span>
            <span className={classes.promotionPrice}>{calculate(label.value, prices)}</span>
        </>
    }

    function renderStreamIds(productStreamIds) {
        if (!Array.isArray(productStreamIds) || !(productStreamIds.length > 0)) {
            return null;
        }

        const labels = {};

        if (!sessionActions.isSalesChannelNordic()) {
            return null;
        }

        if (prices.discount) {
            return null;
        }

        if (!available) {
            return null;
        }

        return null;
    }

    const label = renderStreamIds(streamIds);
    if (!label) {
        return null;
    }

    return <div className={classes.promotionPriceWrapper}>
        { label }
    </div>
}
